module.exports = __webpack_public_path__ + "img/image_14.81b9dfe3.png";